import PageContainer from 'components/shared/containers/PageContainer';
import  { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import { useModel, Branding } from "bcms-react";
import "./styles.css";
/**
 * @function RXPMWPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for RXPMWPage
 */
export default function RXPMWPage(props) {
  // Branding options needed for captures
  const branding = useModel().branding.options;
  const label = branding.payments_label_abi22 ?? "Payments";
  window.BRANDING = { "rxpmw_courseid_abi22" : branding.rxpmw_courseid_abi22 };

  return (<PageContainer className="rxpmw-page integrated-product-page" ignoreTrigger={ true }>
    <PageContentView>
      <CenterContentContainer className='rxpmw-wrapper'>
      <ContentHeaderView text={label}/>
        {/* iFrame for Zelle goes here */}
        <Branding id="checkfree_mobile_version_abi22" exp={ value => value === "CheckFree Mobile Web" || value === "undefined" }>
          <ExternalIframe demo="RXPMW" page={ props.page } key ="RXPMWPage"/>   
        </Branding>   

        <Branding id="checkfree_mobile_version_abi22" exp={ value => value === "CheckFree Next" }>
          <div className="iframe-container">
            <ExternalIframe demo="RXP22" page={ props.page } key ="RXPMW20Page" className="rxp22-iframe"/>
          </div>   
        </Branding>  
      </CenterContentContainer>
    </PageContentView>
  </PageContainer>
       
     );
}
